import { createElement, styled, composedProps } from '@vebox/etui-system';

const H3Element = createElement('h3');
const H3 = styled(H3Element)(composedProps);

export { H3 };
